<template>
  <div class="wrap-app" v-loading="loading">
    <div class="confirm-font">
      <p></p>
      <p>{{ waitConfirmProducts.length ? "待" : "已" }}确认换货</p>
      <p :class="waitConfirmProducts.length ? 'confirm-btn' : ''" @click="confirmHandler">
        {{ waitConfirmProducts.length ? "确认" : ""}}
      </p>
    </div>
    <div class="main-product">
      <el-row
        type="flex"
        align="middle"
        v-for="(good, index) in product"
        :key="index"
        class="product-row"
      >
        <el-col :span="6">
          <div class="good-img-url">
            <img :src="good.imgUrl" style="width:100%;" alt="" />
          </div>
        </el-col>
        <el-col :span="18">
          <div
            class="col-right-item"
            :style="
              index + 1 === product.length
                ? {}
                : { 'border-bottom': '1px solid #f2f2f2' }
            "
          >
            <div>{{ good.name }}</div>
            <div>规格：{{ good.specification }}</div>
            <div>
              <span :class="good.returnGoods ? 'red' : 'green'"
                >{{ good.returnGoods ? "退" : "换" }}货数量</span
              >：{{ good.quantity }}
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="main-detail">
      <span class="title" @click="confirmHandler">订单信息</span>
      <div class="row-flex" v-for="(item, index) in orderDetail" :key="index">
        <div>{{ item.title }}:</div>
        <div v-if="item.value != 'createTime'">{{ detail[item.value] }}</div>
        <div v-else>{{ detail[item.value] | rTime }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  prodcutOrdersDetail,
  confirmExchangeGoods
} from "@/services/api.index";
import _ from 'lodash'
export default {
  data() {
    return {
      detail: {},
      orderDetail: [
        { title: "订单号", value: "code" },
        { title: "订单创建人", value: "createUserName" },
        { title: "下单时间", value: "createTime" },
        { title: "关联用户", value: "customerName" },
        { title: "课题组", value: "researchGroupName" },
        { title: "地址", value: "addressDetail" }
      ],
      product: [],
      loading: false,
      waitConfirmProducts: [],
    };
  },
  created() {
    this.getCoreOrders();
  },
  methods: {
    async getCoreOrders() {
      const { id } = this.$route.query;
      const { data } = await prodcutOrdersDetail(id);
      this.detail = data;
      this.detail.researchGroupName = data.researchGroup.name || "";
      this.detail.customerName = data.customer.realName || "";
      this.detail.addressDetail = data.address
        ? `${data.address.provinceName || ""}${data.address.cityName ||
            ""}${data.address.areaName || ""}${data.address.streetAddress ||
            ""}`
        : "";
      this.waitConfirmProducts = data.mallExchangeGoods.find(v => v.status === "WAIT_CONFIRM") && 
        data.mallExchangeGoods.find(v => v.status === "WAIT_CONFIRM").mallExchangeGoodsItems || [];
      const waitConfirmProducts = _.maxBy(data.mallExchangeGoods, 'id') &&
        _.maxBy(data.mallExchangeGoods, 'id').mallExchangeGoodsItems || [];
      this.product = this.waitConfirmProducts.length ? this.waitConfirmProducts : waitConfirmProducts;
    },
    async confirmHandler() {
      const { id } = this.$route.query;
      await this.$confirm("是否确认换货?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "custom-confirm-class",
        center: true
      });
      this.loading = true;
      try {
        await confirmExchangeGoods(id);
        this.$message.success("订单换货成功！");
        this.$router.push("/");
      } catch (error) {}
      this.loading = false
    }
  }
};
</script>

<style scoped lang="scss">
.confirm-font {
  color: #fff;
  background: #02a7f0;
  text-align: center;
  position: fixed;
  z-index: 100;
  top: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  .confirm-btn {
    height: 25px;
    line-height: 15px;
    padding: 5px 20px;
    border: 1px solid #fff;
    cursor: pointer;
  }
}
.main-product {
  margin-top: 55px;
  padding: 0 10px;
  border-bottom: 5px solid #f2f2f2;
  .col-right-item {
    padding: 10px;
    div {
      padding-bottom: 2px;
    }
  }
  .product-row:last-child {
    border: none;
  }
}
.main-detail {
  padding: 0 10px;
  padding-top: 20px;
  .title {
    font-size: 16px;
    padding: 10px 0;
  }
  .row-flex {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 5px 0;
    div:first-child {
      min-width: 50px;
    }
    div:last-child {
      text-align: right;
    }
  }
}
.red {
  color: #d9001b;
}
.green {
  color: #70b603;
}
</style>
<style>
@media screen and (max-width: 768px) {
  .wrap-app {
    width: 100%;
    height: 100%;
  }
  .el-message-box {
    width: 90% !important;
  }
  .confirm-font {
    width: 100%;
    height: 40px;
    line-height: 40px;
  }
}
@media screen and (min-width: 768px) {
  .wrap-app {
    width: 1250px;
    margin: 0 auto;
    font-size: 14px;
  }
  .good-img-url {
    width: 100px;
  }
  .confirm-font {
    width: 1250px;
    height: 60px;
    line-height: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/confirmExchange/index.vue